import React from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent: IConfigComponent = {
  ...ItemsConfig,
  componentId: 'assets',
  entity: 'asset',
  filtersFetchData: { asset: { isAlive: true } },
};
const Assets = props => {
  const defaultProps = {
    flavorId: 'asset',
    title: 'Assets',
    nameColumns: ['defaultLocation', 'currentLocation', 'lastPosition'],
  };

  return <Items configComponent={defaultConfigComponent} {...defaultProps} {...props} />;
};

export default Assets;
